<template>
  <v-btn
    :height="height"
    :width="width"
    icon
    color="primary"
    @click="$emit('editDate')"
    :loading="loading"
  >
    <div class="d-flex flex-column">
      <v-icon :size="pencilIconSize" style="height: 10px"
        >mdi-pencil-outline</v-icon
      >
      <v-icon :size="minusIconSize" style="height: 5px">mdi-minus</v-icon>
    </div>
  </v-btn>
</template>
<script>
export default {
  props: {
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    pencilIconSize: {
      type: String,
    },
    minusIconSize: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
